import styled, { css } from "styled-components";

import media from "constants/media";

export const ItemStyled = styled.div`
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: stretch;
    width: 100%;
    padding: 20px;

    background-color: var(--color-athensGrey);

    border: 1px solid rgba(0, 23, 75, 0.1);

    ${media.mdUp`
        display: flex;
        align-items: stretch;
        flex-flow: row wrap;
        margin-bottom: 10px;
        padding: 20px;
        width: 100%;

        background-color: var(--color-athensGrey);

        border: 1px solid rgba(0, 23, 75, 0.1);
    `}
`;

export const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    margin-bottom: 10px;

    background-color: var(--color-white);

    ${media.mdUp`
        width: 100px;
        height: 100px;
        margin-bottom: 0;

        background-color: var(--color-white);
     `}
`;

export const Image = styled.img`
    width: 100%;
    max-width: 100%;
`;

export const Title = styled.div`
    margin-bottom: 15px;

    text-align: center;

    ${media.mdUp`
        font-size: 14px;
        line-height:20px;
        text-align: left;
    `}
`;

export const Info = styled.div`
    width: 100%;

    ${media.mdUp`
        width: auto;
        margin-left: 20px;
    `}
`;

export const PriceContainer = styled.div`
    display: flex;
    justify-content: center;

    ${media.mdUp`
        justify-content: flex-start;
        margin-left: auto;
    `}
`;

export const PriceContainerMobile = styled(PriceContainer)`
    ${media.mdUp`
        display: none;
    `}
`;

export const PriceContainerDesktop = styled(PriceContainer)`
    display: none;

    ${media.mdUp`
        display: flex;
    `}
`;

export const Icon = styled.img`
    width: 15px;
    height: 15px;
`;

export const Price = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    font-weight: 500;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: 0;

    > img {
        margin-right: 10px;
    }

    ${media.mdUp`
        justify-content: flex-start;
    `}
`;

export const QuanityContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 15px 0 20px;

    ${media.mdUp`
        justify-content: flex-start;
        margin-top: 0;
    `}
`;

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;

    order: 5;

    ${media.mdUp`
        order: initial;
        padding-right: 20px;
    `}
`;

export const Checkbox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-right: 10px;

    border: 1px solid #ff7871;

    transition: 250ms all ease-in-out;

    ${media.smUp`
        margin-right: 20px;
    `}

    svg {
        display: none;
        width: 11px;
        height: 9px;
    }

    ${({ active }) =>
        active &&
        css`
            svg {
                display: block;
            }
        `}
`;
